module.exports = __webpack_public_path__ + "static/media/instructivooc4.a14afb0f.png";